import { useEffect } from 'react'
import { LoginScreen } from './auth/LoginScreen'
import { useAuthStore } from './auth/useAuth'
import { useCaseStore } from './stores/use-case-store'
import { Shell } from './shell/Shell'

export function App(): JSX.Element {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const isInitializing = useAuthStore((s) => s.isInitializing)
  const initialize = useAuthStore((s) => s.initialize)
  const initCase = useCaseStore((s) => s.initialize)

  // Rehydrate from localStorage on mount. The flag starts at `true` so the
  // first render shows neither LoginScreen nor the shell — a transient splash
  // that flips immediately once localStorage is read (synchronous, no await).
  // Prevents the LoginScreen from flashing on F5 when the session is valid.
  useEffect(() => {
    initialize()
  }, [initialize])

  // W5 hydrate-on-entry: once authenticated, hydrate the active-case context
  // from the doc's XmlPart anchor (XmlPart-first precedence). No-op on a
  // fresh/unbound doc or outside the Word host. F-CASE owns this wiring.
  useEffect(() => {
    if (isAuthenticated) void initCase()
  }, [isAuthenticated, initCase])

  if (isInitializing) {
    return (
      <div
        style={{
          width: 380,
          minHeight: '100vh',
          margin: '0 auto',
          background: '#fff',
        }}
        data-testid="auth-initializing"
      />
    )
  }

  if (!isAuthenticated) {
    return <LoginScreen />
  }

  return <Shell />
}
